export const messages = {
    apiGenericError: "Problème de connexion avec l'API.",
    unknownError: 'Une erreur est survenue.',
    matchingPasswordsError: 'Les mots de passe saisis ne sont pas identiques.',
    passwordLengthError: 'Le mot de passe doit contenir au moins 8 caractères.',
    passwordNumberError: 'Le mot de passe doit contenir au moins 1 chiffre.',
    passwordDoesNotContainAnyUppercaseError: 'Le mot de passe doit contenir au moins 1 majuscule.',
    passwordDoesNotContainAnyLowercaseError: 'Le mot de passe doit contenir au moins 1 minuscule.',
    passwordCharacterError: 'Le mot de passe doit contenir au moins 1 caractère spécial.',
    httpForbiddenMessage: "L'action est interdite.",
    pictureExtensionError: "Le fichier transmis n'est pas une image (PNG, JPG, JPEG ou GIF requis).",
    profilePictureSizeError: 'La photo de profil ne doit pas excéder ',
};
